import { Component, OnInit , Output, Input, EventEmitter} from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { JobsService,AuthService, CandidatesService } from '../../../../services';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-interest-modal',
    templateUrl: './interest-modal.html',
    styleUrls: ['./interest-modal.scss']
})

export class InterestModalComponent implements OnInit {
    @Output() notifyParent = new EventEmitter<any>();
    @Input() isEdit  = false;
    @Input() Interest = {
        id :null ,
        reason : null,
        job_id : null,
        job : null
    }
    isLoading      = false;
    jobs           = [];
    constructor(private toastr: ToastrService,private jobService:JobsService,private authService: AuthService,private candidatesService: CandidatesService, private location: PlatformLocation,public activeModal: NgbActiveModal) {
    	location.onPopState(() => { this.activeModal.close();});
    }

    ngOnInit() {
        this.jobService.getAllBank().subscribe((res: any) =>{this.jobs = res.data;});
    }

    closeModal(){
    	this.activeModal.close({status:true});
    }

    canAdd(){
        return this.isLoading || (this.Interest.job_id == null || this.Interest.reason == null);
    }

    updateUserProfile(){
        
        var _ref = Object.assign({},this.Interest);
        if(_ref.reason ==  null)
            _ref.reason = " "
        this.isLoading = true;
        if(!this.isEdit)
            this.candidatesService.addInterest(_ref,this.authService.user.candidate?.id).subscribe((res: any) =>{
                this.isLoading = false;
                this.Interest = {
                    id :null ,
                    reason : null,
                    job_id : null,
                    job : null
                };
                this.notifyParent.emit(true);
                this.closeModal();
            },(error:any)=>{
                this.isLoading = false;
                this.toastr.error(error.statusText, "update profile information");
            });
        else
            this.candidatesService.updateInterest(_ref,this.authService.user.candidate?.id,this.Interest.id).subscribe((res: any) =>{
                this.isLoading = false;
                this.Interest = res.data;
                this.notifyParent.emit(true);
                this.closeModal();
            },(error:any)=>{
                this.isLoading = false;
                this.toastr.error(error.statusText, "update profile information");
            });
    }
}
